module.exports = __webpack_public_path__ + "img/2017.10.649d5a89.png";